import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FamilyDetailsAU from 'components/Credit24/LoanApplication/FamilyDetailsAU';
import {
  genders,
  maritalStatuses,
  australianOceanicCitizen,
  otherCitizen,
  MEDICARE_CARD_COLOR_GREEN,
} from 'consts';

import { getCountryList } from 'actions/loan';
import { change } from 'redux-form';

const dependentsList = [...Array(7)].map((currentValue, index, array) =>
  ({ type: index.toString(), title: index + 1 === array.length ? `${index}+` : index }));

const FamilyDetailsAUContainer = () => {
  const dispatch = useDispatch();

  const medicareCardType = useSelector((state) => state.loan.customer?.medicare?.cardColour);

  const selectedResidencyStatus = useSelector(
    (state) => state.form.loan?.values?.residencyStatus
  );

  const medicareCase = medicareCardType === MEDICARE_CARD_COLOR_GREEN
    ? australianOceanicCitizen
    : otherCitizen;

  const defaultList = [...australianOceanicCitizen, ...otherCitizen];
  const residencyStatusList = medicareCardType ? medicareCase : defaultList;
  const list = INCREASE_APP ? defaultList : residencyStatusList;

  const countries = useSelector((state) => state.loan.countries);
  const countriesListWithoutAU = countries.filter((item) => item.type !== 'AU');

  const isContentLoading = useSelector((state) => state.loan.isContentLoading);

  useEffect(() => {
    const isResidencyStatusEmpty = !selectedResidencyStatus;
    const isResidencyStatusValid = list.some((item) => item.type === selectedResidencyStatus);
    const shouldResetResidencyStatus = !isResidencyStatusValid && !isResidencyStatusEmpty;

    if (shouldResetResidencyStatus) {
      dispatch(change('loan', 'residencyStatus', null));
    }
  }, [list, selectedResidencyStatus, dispatch]);

  useEffect(() => {
    const shouldFetchCountries = !countriesListWithoutAU.length && !isContentLoading;

    if (shouldFetchCountries) {
      dispatch(getCountryList());
    }
  }, [dispatch, countriesListWithoutAU.length, isContentLoading]);

  return (
    <FamilyDetailsAU
      genders={genders}
      countries={countriesListWithoutAU}
      maritalStatuses={maritalStatuses}
      visaTypes={list}
      dependentsList={dependentsList}
      selectedResidencyStatus={selectedResidencyStatus}
      medicareCardType={medicareCardType}
    />
  );
};

export default FamilyDetailsAUContainer;
